import { Box } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import fiLocale from 'date-fns/locale/fi'
import type { FC } from 'react'

/**
 *
 * @param onChange
 * @param value
 * @param dateToCompare date value to compare against
 * @param dateToCompareFieldName field name of the compared date value
 * @param isStartDate indicates if the value is startDate
 * @param label
 * @param name
 * @param readOnly indicates if component should be in read only state
 * @param isRequired indicates if component is required
 * @param isError indicates if component is in error state
 * @param disabled indicates if component is disabled
 * @returns Custom date picker with functionality to compare against another date
 */
const CustomDatePicker: FC<{
  onChange: (date: Date | null, name: string, keyboardInputValue?: string | undefined) => void
  value: Date | null
  dateToCompare?: Date | null
  dateToCompareFieldName?: string
  isStartDate?: boolean
  label: string
  name: string
  readOnly?: boolean
  isRequired?: boolean
  isError?: boolean
  disabled?: boolean
}> = ({
  onChange,
  value,
  dateToCompare,
  dateToCompareFieldName = '',
  isStartDate,
  label,
  name,
  readOnly = false,
  isRequired = false,
  isError = false,
  disabled = false
}) => {
  const compareDates = (date: Date, dateToCompare: Date): void => {
    if (isStartDate && dateToCompare < date) {
      onChange(date, dateToCompareFieldName)
    }

    if (!isStartDate && dateToCompare > date) {
      onChange(date, dateToCompareFieldName)
    }
  }

  const handleChange = (date: Date | null) => {
    onChange(date, name)
  }

  const handleAccept = (date: Date | null) => {
    // only compare date values, if dateToCompare is provided in props
    if (dateToCompare && date !== null) {
      compareDates(date, dateToCompare)
    }
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fiLocale}>
        <DatePicker
          format={'dd/MM/yyyy'}
          value={value}
          onChange={handleChange}
          onAccept={handleAccept}
          label={label}
          readOnly={readOnly}
          slotProps={{
            textField: {
              sx: {
                backgroundColor: 'background.default'
              },
              required: isRequired,
              error: isError,
              disabled: disabled
            },
            actionBar: {
              actions: ['today']
            }
          }}
        />
      </LocalizationProvider>
    </Box>
  )
}
export default CustomDatePicker
